/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2017, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define(['jquery', '../../lib/@waca/core-client/js/core-client/ui/core/Class'], function($, Class) {

	const SlideoutHelper = Class.extend({
		createAndShowSlideout(slideoutSpec, context) {
			this._slideout = this.glassContext.appController.showSlideOut(slideoutSpec);
			this._slideout.$el.addClass('dashboardPane');
			// force a resize after we show/hide so that we can resize the visualizations
			const resize = () => {
				try {
					$(window).resize();
				} catch (e) {
					console.error(e);
				}
			};
			this._slideout.on('done:show', resize);
			this._slideout.on('hide',() => {
				this._closeSlideout();
				if (context && context.target && context.target.plugin && context.target.plugin.setUnpressed) {
					context.target.plugin.setUnpressed();
				}
				resize();
			});
		},

		isSlideoutOpen() {
			return this._slideout && this._slideout.isOpen();
		},

		_closeSlideout() {
			if (!this._slideout) {
				return;
			}

			this._slideout.hide({
				force: true
			});
			delete this._slideout;
		},

		onHide() {
			if (this.isSlideoutOpen()) {
				this._closeSlideout();
			}
		}
	});

	return SlideoutHelper;
});
